// @flow

import { View } from '@insolus/backbone';
import $        from 'jquery';
import Screen   from '@insolus/screen';

require('@insolus/jquery-ui-components');

class AppView extends View {
    get isPrerendered(): boolean { return true; }

    initialize() {
        this.render();
    }

    onRender() {
        // flow-disable-next-line (@see https://github.com/facebook/flow/issues/396)
        $(this.$el).ui(['errors']);

        if (Screen.is('mobile')) {
            this.$el.addModifier('window-too-small');
        }
    }
}

export default AppView;



// WEBPACK FOOTER //
// ./src/views/themes/front/layout/app.js